import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
 
import "AWS-UI-Components-React/index.css";
import "./styles/index.css";
 
import allReducers from "./reducers";
import App from "./App";
 
const initialState = {};
const store = createStore(
  allReducers,
  initialState,
  composeWithDevTools(applyMiddleware(thunk))
);
 
ReactDOM.render(
  <div className="awsui">
    <Provider store={store}>
      <App />
    </Provider>
  </div>, document.getElementById("root")
);


// WEBPACK FOOTER //
// ./src/index.jsx